import { render, staticRenderFns } from "./shanxiTrainingSupervisionThree.vue?vue&type=template&id=15b0e933&scoped=true"
import script from "./shanxiTrainingSupervisionThree.vue?vue&type=script&lang=js"
export * from "./shanxiTrainingSupervisionThree.vue?vue&type=script&lang=js"
import style0 from "./shanxiTrainingSupervisionThree.vue?vue&type=style&index=0&id=15b0e933&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b0e933",
  null
  
)

export default component.exports